import { twMerge } from 'tailwind-merge';

import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { Text } from '../Text/Text';
import { ReactNode } from 'react';

export const InfoBar = ({
  children,
  linkText,
  linkUrl,
  className = '',
}: {
  children: ReactNode;
  linkText?: string;
  linkUrl?: string;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(`bg-lake-fog flex items-center justify-between rounded-md p-3`, className)}
    >
      <Text className="text-trench mb-0" variant="sm">
        {children}
      </Text>
      {linkText && linkUrl && (
        <InternalLink className="text-[14px]" variant="textPrimary" to={linkUrl}>
          {linkText}
        </InternalLink>
      )}
    </div>
  );
};
